var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dense":"","app":""}},[_c('v-spacer'),_c('span',{staticClass:"text-caption"},[_vm._v("2023 SUREPAY INC. Merchant Version 1.2.2")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }